import { Alert, Button, Dialog, DialogContent, DialogTitle } from '@mui/material';
import React, { useState } from 'react';
import { SimpleForm, useRefresh, useNotify } from 'react-admin';
import LocationTypeInput from 'components/LocationTypeInput';
import PercentInput from 'components/PercentInput';
import create from 'utils/api/create';

export const LocationTypeMarkupBulkUpdateModal = () => {
  const refresh = useRefresh();
  const notify = useNotify();
  const [bulkUpdateLocationTypeMarkupModalOpen, setBulkUpdateLocationTypeMarkupModalOpen] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (data) => {
    try {
      setIsLoading(true);
      const payload = {
        position: {
          location_type_id: data.bulk_update.location_type_id,
          location_type_markup: data.bulk_update.markup,
        },
      };
      await create(`/v3/admin/positions/${data.id}/apply_markups_to_all_states`, payload);
      refresh();
      notify('Location type markup has been successfully updated', { type: 'success' });
    } catch (error) {
      if (error instanceof Error) {
        notify(error.message, { type: 'error' });
      }
    } finally {
      setIsLoading(false);
      setBulkUpdateLocationTypeMarkupModalOpen(false);
    }
  };

  return (
    <>
      <Button onClick={() => setBulkUpdateLocationTypeMarkupModalOpen(true)} disabled={isLoading}>
        Apply Location Type Markup to All States
      </Button>
      <Dialog
        open={bulkUpdateLocationTypeMarkupModalOpen}
        onClose={() => setBulkUpdateLocationTypeMarkupModalOpen(false)}
      >
        <DialogTitle>Apply Location Type Markup to All States</DialogTitle>
        <DialogContent>
          <SimpleForm
            sanitizeEmptyValues
            onSubmit={handleSubmit}
            toolbar={
              <Button type="submit" disabled={isLoading}>
                Update
              </Button>
            }
          >
            <LocationTypeInput
              alwaysOn
              label="Location Type"
              source="bulk_update.location_type_id"
              defaultValue={8}
            />
            <PercentInput alwaysOn label="Location Type Markup (%)" source="bulk_update.markup" />

            <Alert severity="warning" sx={{ maxWidth: 300 }}>
              Saving with an empty value will clear all location type markups for all states.
            </Alert>
          </SimpleForm>
        </DialogContent>
      </Dialog>
    </>
  );
};
